<template><div><h1>VUX V2.1.0Rc.49 released</h1>
<h2><a href="/en/components/form-preview.html">FormPreview</a></h2>
<ul></ul>
<h2><a href="/en/components/x-address.html">XAddress</a></h2>
<ul><li>[feature] support `value-text-align` #921 @linhaobin</li>
<li>[fix] fix `label` styles not conform to `group` settings</li>
</ul>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul></ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.0Rc.49 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.0-rc.49-69.vue?2636b9a8